import { Target, Clock, CheckCircle, TrendingUp } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { ComingSoonWatermark } from '@/components/ComingSoonWatermark';
import { useNavigation } from '@/contexts/NavigationContext';
import { cn } from '@/lib/utils';

export function ActionsPage() {
  const { sectionColor } = useNavigation();

  return (
    <div className="space-y-6">
      <ComingSoonWatermark
        pageKey="risk-actions"
        icon={Target}
        title="Risk Action Tracking Coming Soon"
        description="Comprehensive risk treatment action tracking with milestones, progress monitoring, and effectiveness measurement will be available soon."
      />
      {/* Page Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className={cn("text-3xl font-bold", sectionColor)}>Risk Actions</h1>
          <p className="text-neutral-400 mt-1">
            Track risk treatment actions and remediation plans
          </p>
        </div>
        <button className="btn-primary">
          Create Action
        </button>
      </div>

      {/* Metrics Strip */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Card className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-neutral-400">Total Actions</p>
              <p className="text-2xl font-bold text-white mt-1">89</p>
            </div>
            <div className="p-3 bg-primary-500/20 rounded-lg">
              <Target className="text-primary-400" size={24} />
            </div>
          </div>
        </Card>

        <Card className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-neutral-400">In Progress</p>
              <p className="text-2xl font-bold text-warning-500 mt-1">34</p>
            </div>
            <div className="p-3 bg-warning-500/20 rounded-lg">
              <Clock className="text-warning-500" size={24} />
            </div>
          </div>
        </Card>

        <Card className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-neutral-400">Completed</p>
              <p className="text-2xl font-bold text-success-500 mt-1">48</p>
            </div>
            <div className="p-3 bg-success-500/20 rounded-lg">
              <CheckCircle className="text-success-500" size={24} />
            </div>
          </div>
        </Card>

        <Card className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-neutral-400">Avg Risk Reduction</p>
              <p className="text-2xl font-bold text-success-500 mt-1">23%</p>
            </div>
            <div className="p-3 bg-success-500/20 rounded-lg">
              <TrendingUp className="text-success-500" size={24} />
            </div>
          </div>
        </Card>
      </div>

      {/* Actions Table */}
      <Card className="p-6">
        <h3 className="text-lg font-semibold text-white mb-4">Risk Treatment Actions</h3>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-neutral-800">
                <th className="text-left py-3 px-4 text-sm font-medium text-neutral-400">ID</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-neutral-400">Action</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-neutral-400">Related Risk</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-neutral-400">Owner</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-neutral-400">Due Date</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-neutral-400">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-neutral-800/50 hover:bg-neutral-900/50">
                <td className="py-3 px-4 text-sm font-mono text-primary-400">ACT-001</td>
                <td className="py-3 px-4 text-sm text-white">Implement MFA across all systems</td>
                <td className="py-3 px-4 text-sm font-mono text-neutral-400">RISK-001</td>
                <td className="py-3 px-4 text-sm text-neutral-300">Sarah Johnson</td>
                <td className="py-3 px-4 text-sm text-neutral-300">2024-11-30</td>
                <td className="py-3 px-4"><span className="badge-warning">In Progress</span></td>
              </tr>
              <tr className="border-b border-neutral-800/50 hover:bg-neutral-900/50">
                <td className="py-3 px-4 text-sm font-mono text-primary-400">ACT-002</td>
                <td className="py-3 px-4 text-sm text-white">Update DORA compliance documentation</td>
                <td className="py-3 px-4 text-sm font-mono text-neutral-400">RISK-002</td>
                <td className="py-3 px-4 text-sm text-neutral-300">Michael Chen</td>
                <td className="py-3 px-4 text-sm text-neutral-300">2024-12-15</td>
                <td className="py-3 px-4"><span className="badge-success">Completed</span></td>
              </tr>
              <tr className="hover:bg-neutral-900/50">
                <td className="py-3 px-4 text-sm font-mono text-primary-400">ACT-003</td>
                <td className="py-3 px-4 text-sm text-white">Create knowledge transfer documentation</td>
                <td className="py-3 px-4 text-sm font-mono text-neutral-400">RISK-003</td>
                <td className="py-3 px-4 text-sm text-neutral-300">Emily Rodriguez</td>
                <td className="py-3 px-4 text-sm text-neutral-300">2024-11-20</td>
                <td className="py-3 px-4"><span className="badge-warning">In Progress</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
